// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2_KZK","topBottomGutter":"Layout_topBottomGutter__2sqXL"};